$('.newsletter').on('click',function () {
    $('#formNewsletter').submit();
});

$("#formNewsletter").on('submit', function (e) {
    e.preventDefault();
    $('#emailNews').removeClass('error');

    contLogin = 1;
    if ( $.trim($("#emailNews").val()) == "" ) {
        contLogin = 0;
        $('#emailNews').addClass('error');
    }
    if(contLogin == 0)
    {
        swal({
            text: "Debe digitar un correo electrónico",
            icon: imageURL,
            button: "OK",
        });
        return false;
    }

    var data = $(this).serialize();
    swal({
        text: "Espere un momento",
        icon: imageURL,
        button: false,
        closeOnClickOutside: false,
    });
    $.ajax({
        url: https + "/newsletter",
        method: "POST",
        data: data,
        success: function (data) {
            if ($.trim(data) == "1") {
                swal({
                    text: "Gracias por suscribirte",
                    icon: "success",
                    button: "OK!",
                });
                $("#formNewsletter")[0].reset();
            }else if($.trim(data) == "2"){
                $('#emailNews').addClass('error');
                swal({
                    text: "Este correo electrónico ya \n se encuentra registrado",
                    icon: imageURL,
                    button: "OK",
                });
            }else {
                swal({
                    text: "Error, hubo problemas",
                    icon: imageURL,
                    button: "OK!",
                });
            }
        }
    });

});
